export const APPROVED_STATUS = 'approved'
export const PENDING_STATUS = 'pending_user_review'
export const REFUSED_STATUS = 'refused'
export const TO_CALL_STATUS = 'to_call'
export const TO_SIGN_STATUS = 'to_sign'
export const EXPIRED_STATUS = 'expired'
export const BEING_CREATED = 'being_created'
export const PENDING_MANUAL_ORDERS_VALIDATION = "pending_manual_orders_validation"
export const PENDING_ORDERS_VALIDATION = 'pending_orders_validation'
export const PENDING_ADVISOR_REVIEW = 'pending_advisor_review'

export const FLOW_STATU_QUO = 'statu-quo'
export const FLOW_SAME_ALLOCATION = 'same-as-current-allocation'
export const FLOW_CONVERGE_REFERENCE = 'converge-toward-reference'

export const ARBITRATION_TYPE = 'arbitration'
export const WEALTH_DECISION_TYPE = 'wealth_decision'

export const OUT_OF_PERIMETER_SALEABLE_ISINS = ['FR0011063353']

export const TABLE_PENDING_STATUS = [PENDING_STATUS]
export const TABLE_USER_REVIEW = [APPROVED_STATUS, REFUSED_STATUS, TO_CALL_STATUS, TO_SIGN_STATUS, PENDING_ORDERS_VALIDATION, PENDING_MANUAL_ORDERS_VALIDATION, EXPIRED_STATUS]
export const ALL_STATUS = [APPROVED_STATUS, PENDING_STATUS, REFUSED_STATUS, TO_CALL_STATUS, TO_SIGN_STATUS, EXPIRED_STATUS, PENDING_MANUAL_ORDERS_VALIDATION, PENDING_ORDERS_VALIDATION]

export const MAPPING_SORT = {
  'amount': 'portfolio.amount',
  'date': 'created_at',
  'facility': 'bank.name',
  'kind': 'portfolio.kind',
  'name': 'created_at',
  'profileName': 'user_profile.first_name',
  'status': 'status',
  'type': 'bank_contract.name'
}
